import React from 'react';

import Loading from '../../components/base/Loading';
import { withAuthenticationRequired } from '@auth0/auth0-react';

import { ResearchView } from '@relyant/ui';

export default withAuthenticationRequired(ResearchView, {
  onRedirecting: () => <Loading />,
});
